export default {
  online_payments_off:
    'Dostawa jest włączona, ale klienci nie mogą jej zamówić: dostawa kurierska jest płatna wyłącznie online, a płatności online są wyłączone.',
  gateway_not_verified:
    'Dostawa jest włączona, ale klienci nie mogą jej zamówić: dostawa kurierska jest płatna wyłącznie online, a płatności online są wstrzymane do czasu weryfikacji Twojego konta płatniczego.',
  stripe_processing_fee_missing:
    'Dostawa jest włączona, ale klienci nie mogą jej zamówić: dostawa kurierska jest płatna tylko online, a płatności online są wstrzymane do czasu, aż Twój partner ustawi swoją prowizję za przetwarzanie.',
  turn_on_online_payments: 'Włącz płatności online',
};
